function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useState } from 'react';
import { Card, Input, Space, Spin, Alert } from 'antd';
import { useRequest } from '@umijs/hooks';
import Scenario from './Scenario';
import LoadingContainer from '../loading-container';
import { ScenarioSearchWrapper } from './index.style';
import client from '../feathers';
var {
  Grid
} = Card;
var {
  Search
} = Input;
var gridStyle = {
  width: '100%',
  padding: '0.5rem' //   textAlign: 'center',

};

function getScenarios() {
  return _getScenarios.apply(this, arguments);
}

function _getScenarios() {
  _getScenarios = _asyncToGenerator(function* () {
    var searchText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var query = {
      $eager: '[endpoint.provider, parameters]',
      $sort: {
        likes: -1
      }
    };
    var search = {
      $like: "%".concat(searchText, "%")
    };

    if (searchText) {
      query.name = search;
    }

    var params = {
      query
    };
    var scenarios = yield client.service('scenarios').find(params);
    return scenarios;
  });
  return _getScenarios.apply(this, arguments);
}

export default function ScenarioSearch() {
  var [search, setSearch] = useState(null);
  var {
    data,
    error,
    loading
  } = useRequest(() => getScenarios(search), {
    refreshDeps: [search]
  });

  if (error) {
    return /*#__PURE__*/React.createElement("div", null, "failed to load");
  }

  return /*#__PURE__*/React.createElement(ScenarioSearchWrapper, null, /*#__PURE__*/React.createElement(Space, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Search, {
    placeholder: "Search scenarios...",
    className: "isoSearchNotes" //   value={search}
    ,
    onChange: e => setSearch(e.target.value)
  }), loading ? /*#__PURE__*/React.createElement(LoadingContainer, null) : /*#__PURE__*/React.createElement(React.Fragment, null, data && data.total && /*#__PURE__*/React.createElement("span", null, "".concat(data.total), " scenario results"), /*#__PURE__*/React.createElement(Card, null, data.data.map(scenario => /*#__PURE__*/React.createElement(Grid, {
    style: gridStyle
  }, /*#__PURE__*/React.createElement(Scenario, scenario)))))));
}